import { Component, AfterViewInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { System } from '../../../shared-components/System';
import { AssignmentService } from '../../../student360/assignment/assignment.service';
import { LoginService } from '../../../shared-modules/login/login.service';
import { GradeOverrideCode } from '../../models/grade-override-code.model';

@Component({
    selector: 'app-grade-override-legend',
    templateUrl: './grade-override-legend.component.html'
})
export class GradeOverrideLegendComponent implements AfterViewInit {

    forAssignments: boolean;
    overrideCodes: GradeOverrideCode[];

    constructor(
        private assignmentService: AssignmentService,
        private loginService: LoginService,
        private dialog: MatDialogRef<GradeOverrideLegendComponent>
    ) {
    }

    ngAfterViewInit() {
        if (this.loginService.LoginSettings.V10) {
            this.assignmentService.getOverrideCodes().subscribe((codes) => {
                this.overrideCodes = (this.forAssignments) ? codes.filter(c => c.ForAssignments) : codes.filter(c => c.ForGradeReporting);
            });
        }
    }

    closeClick() {
        this.dialog.close();
    }

    isEven(i: any) {
        return System.isEven(i);
    }
}